import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./app.routes";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { tokenInterceptor } from "./core/auth/interceptors/token.interceptor";
import { provideLuxonDateAdapterConfig } from "./shared/providers/luxon.providers";
import { provideMatFormFieldConfig } from "./shared/providers/form-field.providers";
import { spinnerInterceptor } from "./core/spinner/spinner.interceptor";
import { provideToastr } from "@openng/ngx-toastr";
import {
    provideTippyLoader,
    provideTippyConfig,
    tooltipVariation,
} from "@ngneat/helipopper/config";

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideHttpClient(withInterceptors([tokenInterceptor, spinnerInterceptor])),
        provideLuxonDateAdapterConfig(),
        provideMatFormFieldConfig(),
        provideToastr({ positionClass: "toast-bottom-right", maxOpened: 1, timeOut: 1500 }),
        provideTippyLoader(() => import("tippy.js")),
        provideTippyConfig({
            defaultVariation: "popover",
            variations: {
                tooltip: tooltipVariation,
            },
        }),
    ],
};
